import * as Yup from "yup";
import {
  TLegacyNotificationEmailSms,
  TLegacyRuleList,
} from "../../../api/types/Rule";

// Email/SMS	| x   | x     | x     |       |       |     |   | x
// Save/Alert	|     | x     | x     | x     | x     |     |   |
// Queue	    |     |       | x     |       | x     | x   |   | x
// -----------|-----|-------|-------|-------|-------|-----|---|----
// actionmask | 263 | 65799 | 66311 | 65536 | 66048 | 512 | 0 | 775

// NotifyType
// 0 - Notifications
// 1 - Alerts
// 2 - Both

// form field names
export type TFormFieldNames =
  | "ruleid"
  | "cron_rule"
  | "is_active"
  | "selector"
  | "description"
  | "minimum_interval"
  | "interval_reset"
  | "predefined_actions"
  | "is_email_sms"
  | "is_save_alert"
  | "is_queue"
  | "via_notifications"
  | "via_alerts"
  | "notification_email"
  | "notification_phone"
  | "email_subject"
  | "email_message"
  | "sms_message";

export const ruleDetailsInitialValues = {
  ruleid: "",
  selector: "",
  cron_rule: "",
  is_active: false,
  description: "",
  interval_reset: false,
  minimum_interval: 0,
  predefined_actions: "",
  email: "",
  phone: "",
  is_email_sms: false,
  is_save_alert: false,
  is_queue: false,
  via_notifications: true,
  via_alerts: false,
  notification_email: [] as string[],
  notification_phone: [] as string[],

  email_subject: "",
  email_message: "",
  sms_message: "",

  isassets: false,
  isgroups: false,
  assets: "-",
  groups: "-",
};

export const ruleDetailsYupValidationSchema = Yup.object().shape({
  ruleid: Yup.string()
    .required("Rule title is required")
    .matches(
      /^[a-zA-Z0-9\-_]+$/,
      "Only characters, numbers, hyphens, and underscores are allowed"
    ),
  description: Yup.string().required("Description is required"),
  selector: Yup.string().required("Selector is required"),

  minimum_interval: Yup.number()
    .required("Minimum Interval is required")
    .min(0, "Minimum Interval cannot be negative")
    .integer("Whole number required"),

  email: Yup.string().matches(
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    "Please enter a valid email address"
  ),
  phone: Yup.string().matches(
    /^\d{10}$/,
    "Phone number must be exactly 10 digits"
  ), // Validation for exactly 10 digits
  // notification_email: Yup.array()
  //   .min(1, 'At least one email is required'),
  // notification_phone: Yup.array()
  //   .min(1, 'At least one phone is required'),

  email_subject: Yup.string().required("Email Subject is required"),
  email_message: Yup.string().required("Email Message is required"),
  sms_message: Yup.string().required("SMS Message is required"),
});
